import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-form-section',
    template: `
    <div class="bg-white rounded-lg shadow-sm border border-gray-200">
      <div class="bg-black text-white px-6 py-4 rounded-t-lg">
        <h2 class="text-lg font-medium text-white">{{ title }}</h2>
      </div>
      <div class="px-6 py-6 space-y-4">
        <ng-content></ng-content>
      </div>
    </div>
  `,
})
export class FormSectionComponent {
    @Input() title!: string;
}